import {makeStyles} from "@material-ui/core";

export default makeStyles((theme) => ({
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
  },
  categoryTitle: {
    fontSize: 12,
    fontFamily: 'Roboto-Bold',
    textTransform: 'uppercase',
  },
  optionPercent: {
    fontSize: "28px",
    fontFamily: 'Roboto-Bold',
    textAlign: "right"
  },
  card: {
    borderRadius: 16,
    border: '1px solid #B5BBC2',
    padding: theme.spacing(2),
  },
  aspects: {
    fontSize: 16,
  },
  icon: {
    color: theme.palette.primary.main
  },
  chart: {
    width: "400px",
  }
}));
